<template>
    <div class="event-filter">
        <div>
            <select name="events" id="date-filter" v-model="selected">
                <option value="all" selected>Tous les concerts</option>
                    <option 
                    v-for="month in months" 
                    :value="month" :key="month">{{ month }}</option>
            </select>
            <div class="event-filter__info">
                <span class="event-filter__filter">Filtre:</span>
                <span class="event-filter__current-filter">{{ currentFilter }}</span>
                <span class="event-filter__icon"></span>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                months: [
                    'janvier', 
                    'février', 
                    'mars', 
                    'avril',
                    'mai',
                    'juin',
                    'juillet',
                    'août',
                    'septembre',
                    'octobre',
                    'novembre',
                    'décembre'
                ]
            }
        },
        // methods: {
        //     // filter(e){
        //     //     //console.log('filter')
        //     //     const filterValue = e.target.value;
        //     //     //console.log(filterValue);
        //     //     this.$store.commit('filteringEvents', {
        //     //         filter: filterValue
        //     //     });
        //     // }
        //     triggerOpenFilter(){
        //         document.getElementById('date-filter').focus();
        //         console.log('fuck off');
        //     }
        // },
        computed: {
            currentFilter: function () {
                return this.$store.state.currentFilter === 'all' ? 'Date' : this.$store.state.currentFilter;
            },
            selected: {
                get () {
                    return this.$store.state.currentFilter
                },
                set (e) {
                    // this.$store.commit('updateMessage', value)
                                    //console.log('filter')
                    // console.log(e)
                    // const filterValue = e;
                    //console.log(filterValue);
                    this.$store.commit('filteringEvents', {
                        filter: e
                    });
                }
            }
        }
        
    };
</script>
<style scoped lang="scss">
    .event-filter {
        background-color: #ebebeb;
        z-index: 100;
        overflow: hidden;

        >div {
            position: relative;
            max-width: 1200px;
            padding: 0 20px;
            margin: 0 auto;
            height: 50px;
            font-size: 1.2rem;
        }
    }

    .event-filter__info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #ebebeb;
        padding: 0 20px;
        pointer-events: none;
        box-sizing: border-box;
        cursor: pointer;
    }

    select {
        height: 100%;
        width: 100%;
    }

    .event-filter__filter {
        font-family: 'gt-eesti-light';
        font-size: 1.5px;
        font-size: 1.5rem;
        font-size: min(max(1.5rem, 2vw), 2rem);
        font-size: clamp(1.5rem, 2vw, 2rem);
    }

    .event-filter__current-filter {
        font-family: 'gt-eesti-medium';
        font-size: 1.5px;
        font-size: 1.5rem;
        font-size: min(max(1.5rem, 2vw), 2rem);
        font-size: clamp(1.5rem, 2vw, 2rem);
    }

    .event-filter__icon {
        position: relative;
        color: #979797;
        display: block;
        width: 20px;
        height: 1px;
        background-color: currentColor;

        &:before,
        &:after {
            content: "";
            display: block;
            height: 1px;
            position: absolute;
            background-color: currentColor;
        }

        &:before {
            top: -7px;
            left: -5px;
            width: 30px;
        }

        &:after {
            bottom: -7px;
            left: 4px;
            width: 13px;
        }
    }
</style>
